export const ACTIVE_RMA_STATUS = [
  'DRAFT',
  'PENDING_CONFIRMATION',
  'PENDING_PICK_UP_ADDRESS'
];
